import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Link,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import { IoCloseOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Constants from "../data/Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function BillingDialog(props) {
  const { open, data, onClose } = props;

  return data ? (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1} className="font-extrabold text-lg">
            Billing Details
          </Box>
          <Box>
            <IconButton onClick={onClose}>
              <IoCloseOutline />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <div className="grid" style={{ minWidth: "450px" }}>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Fullname
                </TableCell>
                <TableCell className="">{data.fullname ?? "Not Set"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  mobile
                </TableCell>
                <TableCell className="">{data.mobile ?? "Not Set"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Email
                </TableCell>
                <TableCell className="">{data.email ?? "Not Set"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Address
                </TableCell>
                <TableCell className="">{data.address ?? "Not Set"}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  City
                </TableCell>
                <TableCell className="">{data.city ?? "Not Set"}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  State
                </TableCell>
                <TableCell className="">{data.state ?? "Not Set"}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Pincode
                </TableCell>
                <TableCell className="">{data.zip ?? "Not Set"}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Updated At
                </TableCell>
                <TableCell className="">
                  {moment(data.updatedAt).format(Constants.DATE_TIME_FORMAT)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  ) : (
    ""
  );
}

export default BillingDialog;
